
import { Options, Vue } from "vue-class-component";
import GameExplanation from "./GameExplanation.vue";
import { GameRules } from "@/GameState";

@Options({
  props: {
    mayContinue: Boolean,
  },
  emits: ["startGame", "backGame"],
  components: {
    GameExplanation,
  },
})
export default class Menu extends Vue {
  mayContinue!: Boolean;

  startGame(collapsingIsMove: boolean, collapsesBeforeMove: number) {
    const rules: GameRules = {
      width: 7,
      height: 6,
      collapsingIsMove: collapsingIsMove,
      collapsesBeforeMove: collapsesBeforeMove,
      classicalMovesStart: 3,
      classicalMovesMaximum: 4,
    };
    this.$emit("startGame", rules);
  }
}
